import { render, staticRenderFns } from "./Subcategory.vue?vue&type=template&id=4893f478&scoped=true"
import script from "./Subcategory.vue?vue&type=script&lang=js"
export * from "./Subcategory.vue?vue&type=script&lang=js"
import style0 from "./Subcategory.vue?vue&type=style&index=0&id=4893f478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893f478",
  null
  
)

export default component.exports